import CommentTabsComponent from '@root/core/components/CommentTabs';
import {
  CommentGroup,
  CommentList,
  CommentTabs,
  CommentType,
  CreateComment
} from '@root/core/components/CommentTabs/interface';
import Popup from '@root/core/components/Popup';
import useTranslate from '@root/core/hooks/useTranslate';
import ImportServices from '@root/modules/Sellers/Import/services/import';
import InquiryServices from '@root/modules/Sellers/Inquiry/services/inquiry';
import commentService from '@root/core/components/CommentTabs/commentService';
import ButtonImport from '@root/modules/Warehouse/Inbound/components/Button';
import AttachDown from '@root/modules/Warehouse/Inquiry/components/attachment/AttachDown';
import Comment from '@root/modules/Warehouse/Inquiry/components/comment';
import DetailsPro from '@root/modules/Warehouse/Inquiry/components/details-pro';
import CheckPoint from '@root/modules/Warehouse/Inquiry/components/shipping/CheckPoint';
import ShipmentMethod from '@root/modules/Warehouse/Inquiry/components/shipping/ShipmentMethod';
import ShipmentMethodCanEdit from '@root/modules/Warehouse/Inquiry/components/shipping/ShipmentMethodCanEdit';
import ShippingPlant from '@root/modules/Warehouse/Inquiry/components/shipping/ShippingPlant';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { Button, Card, Typography } from 'antd';
import cloneDeep from 'lodash.clonedeep';
import moment from 'moment';
import { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { ProductContext } from '../../provider/ProductProvider';
import BreadcrumbList from '../../Stock/components/Breadcrumb';
import ImportBox from '../components/ImportBox';
import { message } from 'antd';

const ImportDetailPage = () => {
  const [t] = useTranslate();
  const { Text } = Typography;
  const { productId }: any = useParams();
  const [addressDetail, setAddressDetail] = useState([] as any);
  const [productImportItem, setProductImportItem] = useState([] as any);
  const [productImportQuotation, setProductImportQuotation] = useState(
    [] as any
  );
  const [productImport, setProductImport] = useState([] as any);
  const [nameDetail, setNameDetail] = useState([] as any);
  const [product, setProduct] = useContext<any>(ProductContext);
  const [listHistory, setListHistory] = useState([] as any);
  const history = useHistory();
  const [isCanUpdate, setIsCanUpdate] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isOpenUpdatePopup, setIsOpenUpdatePopup] = useState(false);
  const [isOpenDeletePopup, setIsOpenDeletePopup] = useState(false);
  const [updateData, setUpdate] = useState<any>();
  const [commentList, setCommentList] = useState<CommentList>();
  const [commentAllId, setCommentAllId] = useState();
  const [tabs, setTabs] = useState<CommentTabs[]>([]);

  const Breadcrumb = [
    {
      tittle: '입고 관리',
      url: ''
    },
    {
      tittle: '입고 조회',
      url: '/admin/seller/import'
    },
    {
      tittle: '입고 상세',
      url: ''
    }
  ];

  const getListImportDetail = async () => {
    const importDetail = await ImportServices.getListImportDetail(productId);
    setProductImport(importDetail.data);
    setProductImportQuotation(importDetail.data.quotation);
    setListHistory(importDetail.data.quotation.products);

    const list: any[] = [];
    const arrData: any[] = importDetail.data.quotation.products;
    arrData.forEach((item: any, index: number) => {
      list.push({
        id: item.id,
        productName: item.productName,
        width: item.width,
        height: item.height,
        length: item.length,
        demensionUnit: item.demensionUnit,
        weight: item.weight,
        weightUnit: item.weightUnit,
        estimateQuantity: item.estimateQuantity,
        averageMonthSale: item.averageMonthSale,
        sku: item.sku,
        eanUpc: item.eanUpc,
        asin: item.asin,
        packedMethod: item.packedMethod,
        storageMethod: item.storageMethod,
        dangerousGoods: item.dangerousGoods,
        lotProduct: item.lotProduct,
        image: item?.image?.url
      });
    });
    setProductImportItem(list);
    setNameDetail(importDetail.data.quotation.seller);
    setProduct(importDetail.data.quotation.seller);
    setIsCanUpdate(importDetail.data.impStatus === 'Request To Import');
    setUpdate({
      products: list,
      shipmentMethod: importDetail.data.quotation.shipmentMethod,
      shipmenDetail: importDetail.data.quotation.shipmentDetail,
      shippingPlanEtd: importDetail.data.quotation.shippingPlanEtd,
      shippingPlanEta: importDetail.data.quotation.shippingPlanEta,
      checkPoint: importDetail.data.quotation.checkPoint
    });

    console.log(importDetail?.data?.impStatus);
    switch (importDetail?.data?.impStatus) {
      case 'Request To Import':
        setTabs([]);
        break;
      case 'Import Completed':
        setTabs([
          {
            title: 'Comment',
            type: CommentType.COMMON,
            description: 'Comment from Customer :'
          }
        ]);
        break;
      case 'Approved':
        setTabs([
          {
            title: 'Comment',
            type: CommentType.COMMON,
            description: 'Comment from Customer :'
          },
          {
            title: 'Request modify',
            description: 'Reasons for modification from customer :',
            type: CommentType.REQUEST_MODIFY,
            options: []
          },
          {
            title: 'Request delete',
            description: 'Reasons for deletion from Customer :',
            type: CommentType.REQUEST_DELETE,
            options: []
          }
        ]);
        break;
    }
  };

  const getCommentList = async (showLoading?: Boolean) => {
    if (showLoading) {
      // setLoading(true);
    }
    const comments = await commentService.getComments({
      group: CommentGroup.INBOUND_DETAIL,
      itemId: productId
    });
    setCommentList(comments);
    if (showLoading) {
      // setLoading(false);
    }
  };

  const onSendComment = async (body: CreateComment, id?: number) => {
    // setLoading(true);
    // send comment
    if (id) {
      await commentService.updateComment(id, body);
    } else {
      await commentService.sendComment(body);
    }
    await getCommentList();
    // setLoading(false);
  };

  const handleDelete = async () => {
    await ImportServices.removeImport(productId);
    history.push(`/admin/seller/import`);
  };
  const handleUpdate = async () => {
    if (updateData) {
      if (commentAllId) {
        await commentService.editedRequest(commentAllId);
        setCommentAllId(undefined);
      }
      try {
        await InquiryServices.updateQuote(
          productImportQuotation.id,
          updateData
        );
        history.goBack();
      } catch (error: any) {
        message.error(`${error?.response?.data?.message}`);
        setIsOpenUpdatePopup(false);
      }
    }
  };

  useEffect(() => {
    getListImportDetail();
    getCommentList();
  }, []);

  const listCommentImport: any[] = [productImport];
  return (
    <>
      <BreadcrumbList listBreadcrumb={Breadcrumb} />
      <div className="admin-container">
        <Card
          bordered={false}
          className="admin-card btnImport"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          {/* <div className="header-detail"> */}
          {/* <div className="wrapShow">
              <div className="detail --center">
                <Text keyboard disabled>
                  {productImportQuotation.warehouse?.name}
                </Text>
              </div>
              <div className="detail">
                <Text keyboard disabled>
                  {productImportQuotation.warehouse?.detailAddress}
                </Text>
              </div>
            </div> */}
          {/* <Button>
              {productImport.impStatus === 'Request To Import'
                ? '입고요청'
                : productImport.impStatus === 'Import Completed'
                ? '입고완료'
                : '입고승인'}
            </Button>
          </div> */}
          <div
            className=""
            style={{
              backgroundColor: 'white',
              padding: '20px 10px',
              borderRadius: '6px'
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                // padding: '0 10px 30px',
                background: 'white',
                borderBottom: '1px solid #d9d9d9'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '0 10px 30px',
                  background: 'white'
                }}
              >
                <p
                  style={{
                    marginBottom: '0px',
                    fontWeight: 'bold',
                    fontSize: '15px'
                  }}
                >
                  {nameDetail.companyName}
                </p>
                <p
                  style={{
                    marginBottom: '0px',
                    marginLeft: '10px',
                    color: '#747274'
                  }}
                >
                  {nameDetail.email}
                </p>
              </div>
              <div className="header-detail" style={{ padding: 0 }}>
                {/* <div className="wrapShow">
              <div className="detail --center">
                <Text keyboard disabled>
                  {productImportQuotation.warehouse?.name}
                </Text>
              </div>
              <div className="detail">
                <Text keyboard disabled>
                  {productImportQuotation.warehouse?.detailAddress}
                </Text>
              </div>
            </div> */}
                <Button>
                  {productImport.impStatus === 'Request To Import'
                    ? '입고요청'
                    : productImport.impStatus === 'Import Completed'
                    ? '입고완료'
                    : '입고승인'}
                </Button>
              </div>
            </div>
            {isCanUpdate ? (
              <div style={{ textAlign: 'right', margin: '20px 0' }}>
                {!isUpdate ? (
                  <>
                    <Button
                      style={{
                        border: 0,
                        borderBottom: '1px solid gray',
                        padding: '0'
                      }}
                      onClick={() => setIsUpdate(true)}
                    >
                      Save
                    </Button>
                    <span style={{ padding: '0 10px' }}>|</span>
                    <Button
                      style={{
                        border: 0,
                        borderBottom: '1px solid gray',
                        padding: '0'
                      }}
                      onClick={() => setIsOpenDeletePopup(true)}
                    >
                      Delete
                    </Button>
                  </>
                ) : (
                  <Button
                    style={{
                      border: 0,
                      borderBottom: '1px solid gray',
                      padding: '0'
                    }}
                    onClick={() => setIsOpenUpdatePopup(true)}
                  >
                    Save
                  </Button>
                )}
              </div>
            ) : null}
            {productImportItem.map((item: any, index: number) => {
              return (
                <DetailsPro
                  productName={item.productName}
                  width={item.width}
                  height={item.height}
                  length={item.length}
                  demensionUnit={item.demensionUnit}
                  weight={item.weight}
                  weightUnit={item.weightUnit}
                  estimateQuantity={item.estimateQuantity}
                  averageMonthSale={item.averageMonthSale}
                  sku={item.sku}
                  eanUpc={item.eanUpc}
                  asin={item.asin}
                  packedMethod={item.packedMethod}
                  storageMethod={item.storageMethod}
                  dangerousGoods={item.dangerousGoods === true ? 1 : 0}
                  lotProduct={
                    item.lotProduct.charAt(0).toUpperCase() +
                    item.lotProduct.slice(1)
                  }
                  img={item.image}
                  isUpdate={isUpdate}
                  onChange={(e: any) => {
                    const product = updateData?.products?.[index];
                    if (product) {
                      const products = cloneDeep(updateData.products);
                      const packedMethod = (e?.packedMethod ?? []).join(', ');
                      const storageMethod = (e?.storageMethod ?? []).join(', ');

                      products[index] = {
                        ...e,
                        id: item.id,
                        dangerousGoods: e?.dangerousGoods === 1,
                        packedMethod:
                          packedMethod === 'Direct input'
                            ? e?.packedInput
                            : packedMethod,
                        storageMethod:
                          storageMethod === 'Direct input'
                            ? e?.storageMethodInput
                            : storageMethod,
                        lotProduct:
                          e?.lotProduct === 'Direct input'
                            ? e?.lotProductInput
                            : e?.lotProduct
                      };
                      setUpdate({
                        ...updateData,
                        products
                      });
                    }
                  }}
                />
              );
            })}
            <div style={{ display: 'flex', marginTop: '15px', gap: '10px' }}>
              <ShipmentMethodCanEdit
                shipmentMethod={productImportQuotation.shipmentMethod}
                shipmenDetail={productImportQuotation.shipmentDetail}
                onchange={(e: any) =>
                  setUpdate({
                    ...updateData,
                    ...e
                  })
                }
                isUpdate={isUpdate}
              />
              <ShippingPlant
                shippingPlanEtd={productImportQuotation.shippingPlanEtd}
                shippingPlanEta={productImportQuotation.shippingPlanEta}
                onChange2={(e: any) => {
                  setUpdate({ ...updateData, ...e });
                }}
                isDisabled={!isUpdate}
              />
              <CheckPoint
                checkPoint={productImportQuotation.checkPoint}
                statusBox={isUpdate}
                handleChange={(v: any) =>
                  setUpdate({ ...updateData, checkPoint: v.target.value })
                }
              />
            </div>
            <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
              {listCommentImport.map((item: any) => (
                <>
                  <AttachDown
                    label="Customer’s attachments"
                    documents={item.attachments}
                  />
                  <Comment
                    title="Comment from Customer :"
                    date={
                      item.sellerCommentDate
                        ? formatDateTime(item.sellerCommentDate)
                        : ''
                    }
                    content={item.sellerComment}
                    btnText=""
                  />
                </>
              ))}
            </div>
            <Comment
              title="Comment from Warehouse :"
              date={
                productImport.WarehouseCommentDate
                  ? formatDateTime(productImport.WarehouseCommentDate)
                  : ''
              }
              content={productImport.warehouseComment}
            />

            {isUpdate ? null : (
              <CommentTabsComponent
                tabs={tabs!}
                itemId={productId}
                commentGroup={CommentGroup.INBOUND_DETAIL}
                refectComments={getCommentList}
                commentList={commentList!}
                onSend={onSendComment}
                removeItem={handleDelete}
                removeTitle="입고 신청 내용을 삭제 하시겠습니까?"
                updateItem={(commentId: any) => {
                  document
                    .getElementsByClassName('ant-layout-content')[0]
                    .scrollTo(0, 0);
                  setCommentAllId(commentId);
                  setIsUpdate(true);
                  setIsCanUpdate(true);
                }}
              />
            )}

            <ImportBox />
            <div className="importBtn">
              <div className="button-container">
                <Button
                  style={{ borderRadius: '9px' }}
                  type="default"
                  onClick={() => {
                    history.push({
                      pathname: `/admin/seller/request`,
                      state: {
                        idImport: productId
                      }
                    });
                  }}
                  disabled={
                    productImport.impStatus === 'Import Completed'
                      ? false
                      : true
                  }
                >
                  반환 요청
                </Button>
              </div>
              <div className="button-container">
                <Button
                  style={{ borderRadius: '9px' }}
                  className="renueProduct"
                  onClick={() => {
                    history.push({
                      pathname: `/admin/seller/request`,
                      state: {
                        idImport: productId
                      }
                    });
                  }}
                  disabled={
                    productImport.impStatus === 'Import Completed'
                      ? false
                      : true
                  }
                >
                  폐기 요청
                </Button>
              </div>
            </div>
          </div>
        </Card>
      </div>

      <Popup
        styleBackground="white"
        styleColor="#2A2D51"
        visible={isOpenUpdatePopup}
        title="저장 하시겠습니까?"
        textCancel="취소"
        textOk="확인"
        action_oke={handleUpdate}
        action_cancel={() => setIsOpenUpdatePopup(false)}
      />
      <Popup
        styleBackground="white"
        styleColor="#2A2D51"
        visible={isOpenDeletePopup}
        title="입고 신청 내용을 삭제 하시겠습니까?"
        textCancel="취소"
        textOk="확인"
        action_oke={handleDelete}
        action_cancel={() => setIsOpenDeletePopup(false)}
      />
    </>
  );
};

export default ImportDetailPage;
